import { render, staticRenderFns } from "./MachineMaintenanceCreate.vue?vue&type=template&id=2468d502&"
import script from "./MachineMaintenanceCreate.vue?vue&type=script&lang=ts&"
export * from "./MachineMaintenanceCreate.vue?vue&type=script&lang=ts&"
import style0 from "./MachineMaintenanceCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports